module.exports = __webpack_public_path__ + "assets/img/12_146.ef19704e.jpg";